<template>
  <div class="group-comment-sidebar">
    <b-sidebar position="absolute"
               :right="true"
               :fullheight="true"
               :overlay="false"
               :open="editingGroupComment !== null"
               @close="cancelEditingGroupComment">
      <div class="group-comment-sidebar-contents">
        <div class="sidebar-header">
          <span>
            {{ headerText }}
          </span>
        </div>
        <div class="sidebar-body">
          <b-input v-model="model.comment" 
                   type="textarea"
                   size="is-medium"
                   :loading="loading"
                   expanded>
          </b-input>
        </div>
        <div class="sidebar-footer">
          <div class="sidebar-footer-controls">
            <b-button @click="update" class="is-blue" :loading="loading">Opdater</b-button>
            <b-button @click="cancelEditingGroupComment" class="is-text">Annuller</b-button>
          </div>
          <div class="sidebar-footer-updated content p-2 has-text-centered">
            {{ latestUpdateText }}
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import APISTATE from '../../enums/APISTATE';

export default {
  name: 'group-comment-sidebar',
  data: () => ({
    model: {}
  }),
  computed: {
    ...mapGetters('groupComments', ['editingGroupComment', 'groupCommentMeta', 'groupCommentsApiState']),
    headerText() {
      return `Kommentar for Gruppe ${this.groupCommentMeta.group} - ${this.groupCommentMeta.date}`;
    },
    latestUpdateText() {
      if (this.model?._UpdatedByName === undefined)
        return "Kommentar endnu ikke oprettet";

      const duration = moment().diff(moment(this.model._LatestUpdate), "milliseconds");
      const durationText = duration > 0 ? moment.duration(duration).humanize() : '';

      return `Opdateret ${durationText} siden af ${this.model?._UpdatedByName}`;
    },
    loading() {
      return this.groupCommentsApiState === APISTATE.LOADING;
    }
  },
  methods: {
    ...mapActions('groupComments', ['cancelEditingGroupComment', 'commitEditingGroupComment']),
    update() {
      this.commitEditingGroupComment(this.model);
    },
  },
  watch: {
    'editingGroupComment'(newValue) {
      this.model = {...newValue};
    }
  }
}
</script>

<style lang="scss">
.group-comment-sidebar {
  .group-comment-sidebar-contents {
    flex: 1 0 auto;
    border: 3px solid $border;

    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: stretch;

    .sidebar-header {
      flex: 0 1 auto;
      padding: 20px;
    }
    .sidebar-body {
      flex: 1 0 auto;
      padding: 0 10px;
      .is-expanded,
      .textarea {
        height: 100%;
      }
    }
    .sidebar-footer {
      flex: 0 1 auto;
      
      .sidebar-footer-controls {
        padding: 20px;

      }
      .sidebar-footer-updated {
        background-color: $border;
      }
    }
  }
}
</style>